import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceMarqueeRenderComponent } from './render/slice-marquee-render.component';


export const sliceMarqueRenderModuleEntryComponents = [
  SliceMarqueeRenderComponent,
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  exports: [
    sliceMarqueRenderModuleEntryComponents
  ],
  declarations: sliceMarqueRenderModuleEntryComponents
})
export class SliceMarqueeRenderModule {}

export default sliceMarqueRenderModuleEntryComponents;
